import React, { useState } from "react";
import Dropdown from "../Dropdown/Dropdown";
import Header from "../Header/Header";

import {
  HeroContainer,
  HeroWrapper,
  HeroLeft,
  HeroRight,
  ImageWrapper,
  ScrollDown,
  ScrollLink,
} from "./HeroElements";

function Hero() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <main>
      <Dropdown isOpen={isOpen} toggle={toggle} />
      <Header toggle={toggle} />
      <HeroContainer>
        <HeroWrapper>
          <HeroLeft>
            <h1>Hi, I'm Ashish Kumar Karn</h1>
            {/* <h5>Frontend Developer</h5> */}
            <p className="description">
              I'm a software developer skilled in Full-Stack Development and
              Software Architecture. I enjoy discussing and building systems at
              scale. Let's connect and chat about
              systems, development, or anything in between!
            </p>
          </HeroLeft>
          <HeroRight>
            <ImageWrapper>
              <img src="./hero-img.png" alt="Ashish Karn" />
            </ImageWrapper>
          </HeroRight>
        </HeroWrapper>
        <ScrollDown to="projects">
          <ScrollLink>
            Scroll down
            <img src="./scroll-down.svg" alt="scroll-down" />
          </ScrollLink>
        </ScrollDown>
      </HeroContainer>
    </main>
  );
}

export default Hero;
